module.exports = __webpack_public_path__ + "img/settings.7d5dfe38.png";